import request from '@/utils/request';

// 新增客户留资
export function addChance(data) {
    return request({
        url: `/control/chance`,
        method: 'post',
        data
    });
}


// 新增雇佣客户留资
export function addEmploymentReservation(data) {
    return request({
        url: `/control/retention`,
        method: 'post',
        data
    });
}